import {
    SOCIETY_GET_COUNTRIES,
    SOCIETY_GET_STATES,
    SOCIETY_GET_CITIES
} from '../../index.types';

export function getCountries() {
    return {
        type: SOCIETY_GET_COUNTRIES
    }
}

export function getStates(data) {
    return {
        type: SOCIETY_GET_STATES,
        data
    }
}

export function getCities(data) {
    return {
        type: SOCIETY_GET_CITIES,
        data
    }
}
